
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './components/Layout/Layout';
import PrivateRoute from './components/auth/PrivateRoute';
import Home from './pages/Home';
import Locations from './pages/Configs/Locations';
import ItemCategories from './pages/Configs/ItemCategories';
import ItemSubCategories from './pages/Configs/ItemSubCategories';
import AddItem from './pages/Items/AddItem';
import EditItem from './pages/Items/EditItem';
import Inventory from './pages/Items/Inventory';
import ViewItemByToken from './pages/Items/ViewItemByToken';
import Users from './pages/Users/Users';
import AddUser from './pages/Users/AddUser';
import EditUser from './pages/Users/EditUser';
import Login from './pages/Login';
import RequestRecoverPassword from './pages/RequestRecoverPassword';
import ResetPassword from './pages/ResetPassword';
import Reports from './pages/Reports/Reports';
const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <Routes>     


        <Route path="/" element={
            <PrivateRoute>
            <Layout >
              <Home />
            </Layout> 
          </PrivateRoute>
        } />  


        <Route path="/locations" element={
            <PrivateRoute>
            <Layout routes={[{ name: "Inicio", url: "/", isActive: false }, { name: "Ubicaciones", url: "/locations", isActive: true }]} >
              <Locations />
            </Layout> 
          </PrivateRoute>
        } />


        <Route path="/itemCategories" element={
            <PrivateRoute>
            <Layout routes={[{ name: "Inicio", url: "/", isActive: false }, { name: "Categorías", url: "/categories", isActive: true }]} >
              <ItemCategories />
            </Layout> 
          </PrivateRoute>
        } />
         <Route path="/ItemSubCategories" element={
            <PrivateRoute>
            <Layout routes={[{ name: "Inicio", url: "/", isActive: false }, { name: "Categorías", url: "/categories", isActive: true }]} >
              <ItemSubCategories />
            </Layout> 
          </PrivateRoute>
        } />


        <Route path="/additem" element={
            <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false }, 
              { name: "Inventario", url: "/inventory", isActive: false },
              { name: "Agregar objeto", url: "#", isActive: true }
              ]} >
              <AddItem />
            </Layout> 
          </PrivateRoute>
        } />

       <Route path="/editItem/:id" element={
            <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false }, 
              { name: "Inventario", url: "/inventory", isActive: false },
              { name: "Editar objeto", url: "#", isActive: true }
              ]} >
              <EditItem />
            </Layout> 
          </PrivateRoute>
        } />

       <Route path="/inventory" element={
            <PrivateRoute>
            <Layout routes={[
              { name: "Inicio", url: "/", isActive: false }, 
              { name: "Inventario", url: "/inventory", isActive: true },
              { name: "Agregar objeto", url: "/additem", isActive: false }
              ]} fluid={true} >
              <Inventory />
            </Layout> 
          </PrivateRoute>
        } />


    <Route path="/users" element={
          <PrivateRoute>
          <Layout routes={[{ name: "Inicio", url: "/", isActive: false }, { name: "Usuarios", url: "/users", isActive: true }, { name: "Agregar usuario", url: "/AddUser", isActive: false }]} >
            <Users />
          </Layout> 
        </PrivateRoute>
      } /> 
      <Route path="/adduser" element={
          <PrivateRoute>
          <Layout routes={[{ name: "Inicio", url: "/", isActive: false }, { name: "Usuarios", url: "/users", isActive: false }, { name: "Agregar usuario", url: "/AddUser", isActive: true }]} >
            <AddUser />
          </Layout> 
        </PrivateRoute>
      } /> 
        
      <Route path="/editUser/:id" element={
          <PrivateRoute>
          <Layout routes={[{ name: "Inicio", url: "/", isActive: false }, { name: "Usuarios", url: "/users", isActive: false }, { name: "Editar usuario", url: "", isActive: true }]} >
            <EditUser />
          </Layout> 
        </PrivateRoute>
      } /> 

      <Route path="/reports" element={
        <PrivateRoute>
          <Layout routes={[
            { name: "Inicio", url: "/", isActive:false },
            { name: "Reportes", url: "/Reports", isActive: true}]}>
            <Reports />
          </Layout>
        </PrivateRoute>
      }/>

      



          
         <Route path="/login" element={<Login />} />
         <Route path="/requestRecoverPassword" element={<RequestRecoverPassword />} />
         <Route path="/ResetPassword/:id" element={<ResetPassword />} />
         <Route path="/viewItem/:token" element={<ViewItemByToken />} />

      </Routes>
    </Router>
  </React.StrictMode>
); 

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
